import { toURLSearchParams } from '@wix/metro-runtime';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/metro-runtime';
function resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl(opts) {
    const domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/cloud-data',
                destPath: '',
            },
        ],
        'code._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/v1/connector',
                destPath: '/v1/connector',
            },
            {
                srcPath: '/_api/data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/v1/connector',
                destPath: '/v1/connector',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
        ],
        'cloud-data.wix-code.com': [
            {
                srcPath: '',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
            {
                srcPath: '/_api/data',
                destPath: '',
            },
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/cloud-data/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/cloud-data/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
            {
                srcPath: '/_api/data',
                destPath: '',
            },
            {
                srcPath: '/_api/cloud-data',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/_api/cloud-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/_api/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
            {
                srcPath: '/_api/cloud-data/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/_api/cloud-data/v2/bulk',
                destPath: '/v2/bulk',
            },
            {
                srcPath: '/_api/cloud-data/v2/items',
                destPath: '/v2/items',
            },
            {
                srcPath: '/_api/cloud-data/v2/dbs/tasks',
                destPath: '/v2/dbs/tasks',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/_api/cloud-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/_api/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
            {
                srcPath: '/_api/cloud-data/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/_api/cloud-data/v2/bulk',
                destPath: '/v2/bulk',
            },
            {
                srcPath: '/_api/cloud-data/v2/items',
                destPath: '/v2/items',
            },
            {
                srcPath: '/_api/cloud-data/v2/dbs/tasks',
                destPath: '/v2/dbs/tasks',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/cloud-data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/cloud-data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/data/v1/schemas',
                destPath: '/v1/schemas',
            },
            {
                srcPath: '/_api/data/dbs/tasks',
                destPath: '/dbs/tasks',
            },
            {
                srcPath: '/_api/cloud-data/v1/wix-data',
                destPath: '/v1/wix-data',
            },
            {
                srcPath: '/_api/cloud-data/v1/data-settings',
                destPath: '/v1/data-settings',
            },
            {
                srcPath: '/_api/data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/_api/cloud-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/_api/data/v1/data-collection-sharing',
                destPath: '/v1/data-collection-sharing',
            },
            {
                srcPath: '/_api/cloud-data/v2/collections',
                destPath: '/v2/collections',
            },
            {
                srcPath: '/_api/cloud-data/v2/bulk',
                destPath: '/v2/bulk',
            },
            {
                srcPath: '/_api/cloud-data/v2/items',
                destPath: '/v2/items',
            },
            {
                srcPath: '/_api/cloud-data/v2/dbs/tasks',
                destPath: '/v2/dbs/tasks',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/wix-data/v1/collections',
                destPath: '/v1/wix-data/collections',
            },
            {
                srcPath: '/wix-data/v1/external-database-connections',
                destPath: '/v1/external-database-connections',
            },
            {
                srcPath: '/wix-data/v2/indexes',
                destPath: '/v2/indexes',
            },
            {
                srcPath: '/wix-data/v1/items',
                destPath: '/v1/items',
            },
            {
                srcPath: '/wix-data/v1/bulk',
                destPath: '/v1/bulk',
            },
            {
                srcPath: '/wix-data/v1/external-databases',
                destPath: '/v1/external-databases',
            },
            {
                srcPath: '/wix-data/v2',
                destPath: '/v2',
            },
        ],
        'www.wixgateway.com': [
            {
                srcPath: '/wix-data/v1/items',
                destPath: '/v1/items',
            },
            {
                srcPath: '/wix-data/v1/bulk',
                destPath: '/v1/bulk',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/cloud-data/v2',
                destPath: '/v2',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
/**
 * Creates a new data collection.
 *
 * The request body must include an ID, details for at least 1 field, and a permissions object. If any of these are missing, the collection isn't created.
 */
export function createDataCollection(payload) {
    function __createDataCollection({ host }) {
        const serializedData = transformPaths(payload, [
            {
                transformFn: transformSDKTimestampToRESTTimestamp,
                paths: [
                    { path: 'collection.createdDate' },
                    { path: 'collection.updatedDate' },
                ],
            },
            {
                transformFn: transformSDKFloatToRESTFloat,
                paths: [
                    { path: 'collection.fields.numberRange.min' },
                    { path: 'collection.fields.numberRange.max' },
                ],
            },
        ]);
        const metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'POST',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.CreateDataCollection',
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({ protoPath: '/v2/collections', data: serializedData, host }),
            data: serializedData,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'collection.createdDate' },
                        { path: 'collection.updatedDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'collection.fields.numberRange.min' },
                        { path: 'collection.fields.numberRange.max' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __createDataCollection;
}
/** Retrieves a data collection by ID. */
export function getDataCollection(payload) {
    function __getDataCollection({ host }) {
        const metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'GET',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.GetDataCollection',
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({ protoPath: '/v2/collections/{dataCollectionId}', data: payload, host }),
            params: toURLSearchParams(payload),
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'collection.createdDate' },
                        { path: 'collection.updatedDate' },
                        { path: 'referencedCollections.createdDate' },
                        { path: 'referencedCollections.updatedDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'collection.fields.numberRange.min' },
                        { path: 'collection.fields.numberRange.max' },
                        { path: 'referencedCollections.fields.numberRange.min' },
                        { path: 'referencedCollections.fields.numberRange.max' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __getDataCollection;
}
/**
 * Retrieves a list of all data collections associated with the site or project.
 *
 * By default, the list is ordered by ID in ascending order.
 */
export function listDataCollections(payload) {
    function __listDataCollections({ host }) {
        const metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'GET',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.ListDataCollections',
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({ protoPath: '/v2/collections', data: payload, host }),
            params: toURLSearchParams(payload),
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'collections.createdDate' },
                        { path: 'collections.updatedDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'collections.fields.numberRange.min' },
                        { path: 'collections.fields.numberRange.max' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __listDataCollections;
}
/**
 * Updates a data collection.
 *
 * A collection ID, revision number, permissions, and at least 1 field must be provided within `options.collection`.
 * If a collection with that ID exists, and if its current `revision` number matches the one provided, it is updated.
 * Otherwise, the request fails.
 *
 * When a collection is updated, its `_updatedDate` property is changed to the current date and its `revision` property is incremented.
 *
 * > **Note:**
 * > After a collection is updated, it only contains the properties included in the `updateDataCollection()` call. If the existing collection has properties with values and those properties
 * > aren't included in the updated collection details, their values are lost.
 */
export function updateDataCollection(payload) {
    function __updateDataCollection({ host }) {
        const serializedData = transformPaths(payload, [
            {
                transformFn: transformSDKTimestampToRESTTimestamp,
                paths: [
                    { path: 'collection.createdDate' },
                    { path: 'collection.updatedDate' },
                ],
            },
            {
                transformFn: transformSDKFloatToRESTFloat,
                paths: [
                    { path: 'collection.fields.numberRange.min' },
                    { path: 'collection.fields.numberRange.max' },
                ],
            },
        ]);
        const metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'PUT',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.UpdateDataCollection',
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({ protoPath: '/v2/collections', data: serializedData, host }),
            data: serializedData,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'collection.createdDate' },
                        { path: 'collection.updatedDate' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'collection.fields.numberRange.min' },
                        { path: 'collection.fields.numberRange.max' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __updateDataCollection;
}
/**
 * Deletes a data collection.
 *
 * > **Note:**
 * > Once a collection is deleted, it can't be restored.
 */
export function deleteDataCollection(payload) {
    function __deleteDataCollection({ host }) {
        const metadata = {
            entityFqdn: 'wix.data.v2.data_collection',
            method: 'DELETE',
            methodFqn: 'com.wixpress.cloud.data.api.collectionservice.DataCollectionService.DeleteDataCollection',
            url: resolveComWixpressCloudDataApiCollectionserviceDataCollectionServiceUrl({ protoPath: '/v2/collections/{dataCollectionId}', data: payload, host }),
            params: toURLSearchParams(payload),
        };
        return metadata;
    }
    return __deleteDataCollection;
}
//# sourceMappingURL=data-v2-data-collection-collections.http.js.map